<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-terminated',
    }"
  >
    <h4 class="mt-6 mb-9">
      Bummer! {{ companyName || 'Your company' }} isn't eligible for a Datapeople account right now.
    </h4>
    <p class="paragraph mb-6">
      Hi {{ firstName }}! Thanks for this information. Unfortunately, because
      {{ companyName || 'your company' }} doesn't seem to meet our technical requirements,
      you're not eligible for a Datapeople account. We've emailed you more information on
      why we can't offer you access at this time. Please reply with any questions – and
      check back if you ever make changes!
    </p>
    <h4 class="mistake mb-4">
      Made a mistake?
    </h4>
    <WizardFooter>
      <h5>
        Email us at
        <a href="mailto:support@datapeople.io?subject=ATS%20Details">
          support@datapeople.io
        </a>
        with information about your ATS, and we'll be happy to review.
      </h5>
    </WizardFooter>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import WizardFooter from '@/components/shared/WizardFooter.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'TerminatedNoAts',
  components: {
    WizardContent,
    WizardFooter,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'companyName']),
  },
  created() {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-873652164/n88iCLvajNQBEMS_y6AD' });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Terminated No Ats' });
  },
};
</script>

<style lang="less" scoped>
.paragraph {
  font-weight: 300;
  font-size: 20px !important;
  line-height: 30px !important;
  text-align: center;
  color: @text-darkest;
}

.mistake {
  font-weight: 500;
  font-size: 20px !important;
  line-height: 30px !important;
  text-align: center;
  color: @text-darkest;
}
</style>
